import Component from './component';

export interface Props {
    authorImage?: string;
    authorName?: string;
    authorDescription?: string;
}

Component.defaultProps = {
    authorImage: null,
    authorName: null,
    authorDescription: null,
};

export default Component;